<template>
  <div>
    <q-dialog
      :visible="isVisible"
      title="退款日志"
      width="750px"
      :innerScroll="false"
      @cancel="onCancel"
      @close="onCancel"
      @confirm="confirm"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        size="small"
      >
        <el-form-item label="通知事件" prop="notificationEvent">
          <el-input v-model="ruleForm.notificationEvent"></el-input>
        </el-form-item>
        <el-form-item label="通知对象" prop="roleName">
          <el-select v-model="ruleForm.roleName" placeholder="请选择活动区域" @change="change">
            <el-option 
              v-for="(item,index) in informObj"
              :value-key="item.roleCode" 
              :key="index" 
              :label="item.roleName" 
              :value="item" 
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知内容" prop="msgContent">
          <el-input type="textarea" v-model="ruleForm.msgContent"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    ruleForm: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("change", newVal);
      },
    },
  },
  data() {
    return {
      loading: false,
      informObj: [],
      rules: {
        notificationEvent: [{ required: true, message: "请输入通知事件", trigger: "blur" }],
        msgContent: [{ required: true, message: "请输入通知内容", trigger: "blur" }]
      },
    };
  },
  mounted() {
    this.pageInfo()
  },
  methods: {
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.messageInform.updateMsgConfig(this.ruleForm)
            .then(res => {
              if (res.success) {
                this.isVisible = false;
               this.$message.success('编辑成功')
               this.$emit('editSuccess')
              }
            })
        }
      });
    },
    change({roleCode,roleName}) {
      this.ruleForm.roleCode = roleCode
      this.ruleForm.roleName = roleName
    },
    pageInfo() {
      this.$api.messageInform.pageInfo({
        pageNum: 1,
        pageSize: 1000,
        filterData: {
          roleName: "",
          appId: "321",
          appCode: "activity-platform",
          subAppId: "601",
        },
      }).then(res => {
        this.informObj = res.data.list 
      })
    },
    onCancel() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="stylus" scoped></style>
